<template>
    <div>
        <navbar-header page-name="Курьер"></navbar-header>
        <CourierStatistic class="body"></CourierStatistic>
    </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import CourierStatistic from '@/components/CourierStatistic'
export default {
  name: 'Statisticlayout',
  data () {
    return {
    }
  },
  components: {
    CourierStatistic,
    NavbarHeader
  }
}
</script>



// WEBPACK FOOTER //
// src/views/StatisticLayout.vue